(function () {
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.money_format);
    }
    return (cents / 100).toFixed(2);
  }

  function fitAccessoryRecSelectWidth(selectEl) {
    if (!selectEl || !selectEl.options.length) return;

    var body = selectEl.closest('.cs-accessory-rec__body');
    var card = selectEl.closest('.cs-accessory-rec__card');
    if (!body || !card) return;

    var measure = document.createElement('span');
    measure.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;pointer-events:none;';
    measure.style.font = window.getComputedStyle(selectEl).font;
    document.body.appendChild(measure);

    var longestTextWidth = 0;
    for (var i = 0; i < selectEl.options.length; i++) {
      measure.textContent = selectEl.options[i].textContent.trim();
      longestTextWidth = Math.max(longestTextWidth, measure.offsetWidth);
    }
    document.body.removeChild(measure);

    var chevronGap = 2;
    var body = selectEl.closest('.cs-accessory-rec__body');
    var bodyWidth = body ? body.clientWidth : 0;
    var selectWidth = longestTextWidth + chevronGap;
    if (bodyWidth > 0) {
      selectWidth = Math.min(selectWidth, bodyWidth);
    }

    selectEl.style.maxWidth = bodyWidth > 0 ? bodyWidth + 'px' : '100%';
    selectEl.style.width = Math.max(selectWidth, 48) + 'px';
  }

  function openAccessoryRecSelect(select) {
    if (!select) return;
    try {
      if (typeof select.showPicker === 'function') {
        select.showPicker();
        return;
      }
    } catch (err) {}
    select.focus({ preventScroll: true });
    select.click();
  }

  function initAccessoryRecVariantPickers() {
    document.querySelectorAll('.cs-accessory-rec__variant-chevron').forEach(function (chevron) {
      chevron.addEventListener('mousedown', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var label = chevron.closest('label.cs-accessory-rec__variant');
        openAccessoryRecSelect(label && label.querySelector('select'));
      });
      chevron.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    document.querySelectorAll('label.cs-accessory-rec__variant').forEach(function (label) {
      label.addEventListener('click', function (e) {
        if (e.target.tagName === 'SELECT') return;
        if (e.target.classList.contains('cs-accessory-rec__variant-chevron')) return;
        e.preventDefault();
        openAccessoryRecSelect(label.querySelector('select'));
      });
    });
  }

  function updateAccessoryRecCard(selectEl) {
    var card = selectEl.closest('.cs-accessory-rec__card');
    if (!card) return;

    var option = selectEl.options[selectEl.selectedIndex];
    var variantId = selectEl.value;
    var price = option.getAttribute('data-price');
    var compareAt = option.getAttribute('data-compare-at');
    var idInput = card.querySelector('[data-accessory-variant-id]');
    var addBtn = card.querySelector('[data-cs-accessory-add-btn]');

    if (idInput) idInput.value = variantId;

    var priceWrap = card.querySelector('[data-cs-accessory-rec-price] .cs-accessory-rec__price-line');
    if (priceWrap && price) {
      var html = '<ins><span class="cs-accessory-rec__amount">' + formatMoney(parseInt(price, 10)) + '</span></ins>';
      if (compareAt && parseInt(compareAt, 10) > parseInt(price, 10)) {
        html += '<del><span class="cs-accessory-rec__amount">' + formatMoney(parseInt(compareAt, 10)) + '</span></del>';
      }
      priceWrap.innerHTML = html;

      if (window.ella && typeof window.ella.checkNeedToConvertCurrency === 'function' && window.ella.checkNeedToConvertCurrency()) {
        if (typeof Currency !== 'undefined' && Currency.convertAll) {
          Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), card.querySelectorAll('.cs-accessory-rec__amount'), 'money_format');
        }
      }
    }

    if (addBtn) {
      if (option.disabled) {
        addBtn.setAttribute('disabled', 'disabled');
      } else {
        addBtn.removeAttribute('disabled');
      }
    }

    var imageUrl = option.getAttribute('data-image');
    var imageAlt = option.getAttribute('data-image-alt');
    var img = card.querySelector('.cs-accessory-rec__media img.cs-accessory-rec__image');
    if (img && imageUrl) {
      img.src = imageUrl;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      if (imageAlt) {
        img.alt = imageAlt;
      }
    }

    fitAccessoryRecSelectWidth(selectEl);
  }

  function openSideCartDrawer() {
    if (window.ella && typeof window.ella.appendDropdownCartForMobile === 'function') {
      window.ella.appendDropdownCartForMobile();
    }

    document.documentElement.classList.add('cart-show');
    if (typeof jQuery !== 'undefined') {
      jQuery('html').addClass('cart-show');
    }

    if (window.ella && typeof window.ella.productCartslider === 'function') {
      window.ella.productCartslider();
    }

    if (typeof jQuery !== 'undefined' && window.innerWidth >= 1200) {
      var wrapperTopCart = jQuery('.wrapper-top-cart');
      var dropdownCart = jQuery('#dropdown-cart');
      var cartIcon = wrapperTopCart.find('[data-cart-toggle]');
      if (wrapperTopCart.length && dropdownCart.length && cartIcon.length && cartIcon.is(':visible')) {
        wrapperTopCart.addClass('is-open');
        dropdownCart.stop(true, true).slideDown(200);
      }
    }
  }

  function refreshCartUiAfterAdd(options) {
    options = options || {};
    var openDrawer = options.openDrawer === true;

    function done() {
      if (openDrawer) {
        openSideCartDrawer();
      }
    }

    if (
      window.ella &&
      typeof window.ella.doUpdateDropdownCart === 'function' &&
      typeof Shopify !== 'undefined' &&
      typeof Shopify.getCart === 'function'
    ) {
      Shopify.getCart(function (cart) {
        window.ella.doUpdateDropdownCart(cart);
        done();
      });
      return;
    }

    if (window.ella && typeof window.ella.updateDropdownCart === 'function') {
      window.ella.updateDropdownCart();
      if (openDrawer) {
        window.setTimeout(done, 300);
      }
      return;
    }

    var cartUrl = (window.router || '') + '/cart.js';
    if (typeof jQuery !== 'undefined') {
      jQuery.getJSON(cartUrl, function (cart) {
        jQuery('[data-cart-count]').text(cart.item_count);
        try {
          window.dispatchEvent(new CustomEvent('cartcount:update', { detail: { cart: cart } }));
        } catch (err) {}
        done();
      });
      return;
    }

    fetch(cartUrl)
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        try {
          window.dispatchEvent(new CustomEvent('cartcount:update', { detail: { cart: cart } }));
        } catch (err) {}
        done();
      })
      .catch(function () {});
  }

  function handleAccessoryRecAddClick(e) {
    e.preventDefault();
    e.stopPropagation();

    var addBtn = e.currentTarget;
    if (addBtn.disabled) return;

    var card = addBtn.closest('.cs-accessory-rec__card');
    var idInput = card && card.querySelector('[data-accessory-variant-id]');
    var variantId = idInput && idInput.value;
    if (!variantId) return;

    addBtn.setAttribute('disabled', 'disabled');
    addBtn.classList.add('is-loading');

    var cartAddUrl = (window.router || '') + '/cart/add.js';
    var payload = 'quantity=1&id=' + encodeURIComponent(variantId);

    if (typeof jQuery !== 'undefined') {
      jQuery.ajax({
        type: 'POST',
        url: cartAddUrl,
        data: payload,
        dataType: 'json',
        beforeSend: function () {
          if (window.ella && typeof window.ella.showLoading === 'function') {
            window.ella.showLoading();
          }
        },
        success: function () {
          refreshCartUiAfterAdd({ openDrawer: true });
        },
        error: function (xhr) {
          var message = 'Could not add to cart';
          try {
            message = JSON.parse(xhr.responseText).description || message;
          } catch (err) {}
          window.alert(message);
        },
        complete: function () {
          addBtn.classList.remove('is-loading');
          var selectEl = card.querySelector('.cs-accessory-rec__variant-select');
          var optionDisabled =
            selectEl &&
            selectEl.options[selectEl.selectedIndex] &&
            selectEl.options[selectEl.selectedIndex].disabled;
          if (!optionDisabled) {
            addBtn.removeAttribute('disabled');
          }
          if (window.ella && typeof window.ella.hideLoading === 'function') {
            window.ella.hideLoading();
          }
        }
      });
      return;
    }

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: payload
    })
      .then(function (res) {
        if (!res.ok) throw res;
        refreshCartUiAfterAdd({ openDrawer: true });
      })
      .catch(function () {
        window.alert('Could not add to cart');
      })
      .finally(function () {
        addBtn.classList.remove('is-loading');
        var selectEl = card.querySelector('.cs-accessory-rec__variant-select');
        var optionDisabled =
          selectEl &&
          selectEl.options[selectEl.selectedIndex] &&
          selectEl.options[selectEl.selectedIndex].disabled;
        if (!optionDisabled) {
          addBtn.removeAttribute('disabled');
        }
      });
  }

  function syncAllAccessoryRecCards() {
    document.querySelectorAll('.cs-accessory-rec__variant-select').forEach(function (selectEl) {
      updateAccessoryRecCard(selectEl);
    });
  }

  function initAccessoryRecommendations() {
    var root = document.querySelector('[data-cs-accessory-recs]');
    if (!root) return;

    syncAllAccessoryRecCards();

    if (root.getAttribute('data-cs-bound') === '1') return;
    root.setAttribute('data-cs-bound', '1');

    document.querySelectorAll('.cs-accessory-rec__variant-select').forEach(function (selectEl) {
      selectEl.addEventListener('change', function () {
        updateAccessoryRecCard(selectEl);
      });
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('.cs-accessory-rec__variant-select').forEach(fitAccessoryRecSelectWidth);
    });

    document.querySelectorAll('[data-cs-accessory-add-btn]').forEach(function (btn) {
      btn.addEventListener('click', handleAccessoryRecAddClick);
    });

    initAccessoryRecVariantPickers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccessoryRecommendations);
  } else {
    initAccessoryRecommendations();
  }

  window.addEventListener('pageshow', function (e) {
    syncAllAccessoryRecCards();
    window.setTimeout(syncAllAccessoryRecCards, 0);
    if (e.persisted) {
      window.setTimeout(syncAllAccessoryRecCards, 200);
    }
  });
})();
